module.exports = __webpack_public_path__ + "static/media/8-web-or-mls-DSC06462.8603b778.jpg";